import React, { HTMLAttributes } from 'react'

import { Menu } from '@services/api/menus'

import { BoxedContent } from '@components/boxed-content'
import { FullContent } from '@components/full-content'
import { Footer } from '@components/footer'
import { Header } from '@components/header'
import { AdConfigProps, SponsorBanner } from '@components/sponsor-banner'
import { SkipLink } from '@components/skip-link'

interface LayoutProps extends HTMLAttributes<HTMLDivElement> {
  mainMenus?: Menu[]
  footerMenus1?: Menu[]
  footerMenus2?: Menu[]
  sponsorKeyword?: string
  ad?: AdConfigProps
  title?: string
  logoHeading?: boolean
  logoUrl?: string
  fullContent?: boolean
}

export const Layout = ({
  children,
  mainMenus,
  footerMenus1,
  footerMenus2,
  title,
  logoHeading,
  logoUrl,
  ad,
  fullContent
}: LayoutProps) => {
  const Content = fullContent ? FullContent : BoxedContent

  return (
    <>
      <SkipLink />
      <BoxedContent>
        <SponsorBanner config={ad} className="mt-20" />
      </BoxedContent>
      <div className="mb-8 min-h-screen">
        <Header
          menus={mainMenus}
          logoUrl={logoUrl}
          title={title}
          logoHeading={logoHeading}
          isFixed={true}
        />
        <Content>
          <main id="main-content" role="main" tabIndex={-1}>
            <div className="pt-4">{children}</div>
          </main>
        </Content>
      </div>
      <Footer menuFooter1={footerMenus1} menuFooter2={footerMenus2} />
    </>
  )
}
